<template>
  <div class="boss-message-wrap">
    <template v-for="(message, i) in allMessages">
      <template v-if="message.key === historyFromKey">
        <!-- ▼ 企業へのメッセージ -->
        <seminar-entry-message-history-from-applicant
          :key="i"
          :body="message.body"
          :subject="message.subject"
          :date="message.date"
          @set-body-and-subject="setBodyAndSubject"
        />
        <!-- ▲ 企業へのメッセージ -->
      </template>
      <template v-else-if="message.key === historyToKey">
        <!-- ▼ 企業からのメッセージ -->
        <seminar-entry-message-history-to-applicant
          :key="i"
          :body="message.body"
          :subject="message.subject"
          :date="message.date"
          :is-read="message.isRead"
          :interview-adjustment="message.interviewAdjustment"
          :is-remind-mail="message.isRemindMail"
        />
        <!-- ▲ 企業からのメッセージ -->
      </template>
    </template>
  </div>
</template>

<script>
import SeminarEntryMessageHistoryToApplicant from '@/components/molecules/SeminarEntryMessageHistoryToApplicant'
import SeminarEntryMessageHistoryFromApplicant from '@/components/molecules/SeminarEntryMessageHistoryFromApplicant'
import _ from 'lodash'

export default {
  components: {
    SeminarEntryMessageHistoryToApplicant,
    SeminarEntryMessageHistoryFromApplicant
  },
  props: {
    entryId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      allMessages: [],
      historyFromKey: 'from',
      historyToKey: 'to'
    }
  },
  watch: {
    entryId: {
      handler () {
        this.fetchAllMessage()
      }
    }
  },
  created () {
    this.fetchAllMessage()
  },
  methods: {
    fetchAllMessage () {
      Promise.all([
        this.fetchFromCandidateMessage(),
        this.fetchToCandidateMessage()
      ]).then((response) => {
        const allMessage = [
          ...response[0].data.map(message => { return this.addKey(message, this.historyFromKey) }),
          ...response[1].data.map(message => { return this.addKey(message, this.historyToKey) })
        ]
        this.$set(this, 'allMessages', _.orderBy(allMessage, ['date'], ['desc']))
      })
    },
    async fetchFromCandidateMessage () {
      return this.$http.secured.get(`/seminar/entries/${this.entryId}/history/from_user_messages`)
    },
    async fetchToCandidateMessage () {
      return this.$http.secured.get(`/seminar/entries/${this.entryId}/history/to_user_messages`)
    },
    addKey (value, key) {
      const copyValue = _.cloneDeep(value)
      copyValue.key = key
      return copyValue
    },
    setBodyAndSubject (data) {
      this.$emit('set-body-and-subject', { body: data.body, subject: data.subject })
    }
  }
}
</script>
